export default "__VITE_ASSET__c6ec0255__"